import { Component, Injectable, ElementRef, OnInit, Inject, ViewChild, ViewChildren, QueryList, OnDestroy } from '@angular/core';
import { BehaviorSubject, merge, Observable } from 'rxjs';
import { FlatTreeControl } from '@angular/cdk/tree';
import { CollectionViewer, SelectionChange } from '@angular/cdk/collections';
import { Subject } from 'rxjs';
import { AdminService } from './admin.service';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { filter, map, takeUntil } from 'rxjs/operators';
import { MatSelectionList, MatSelectionListChange } from '@angular/material/list';
import { MatDialog } from '@angular/material/dialog';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatAccordion } from '@angular/material/expansion';
import { TCCPConstantValues } from '../shared/models/tccp-constants';
import { Subscription } from 'rxjs';
import { TCCPLocalStorageService } from '../shared/services/tccp-local-storage.service';
import { ConfirmModalComponent } from '../shared/components/confirm-modal/confirm-modal.component';
import * as _ from 'lodash';
import { TCCPCommonService } from '../shared/services/tccp-common.service';
import { Permission } from '../shared/models/user-role';
import { ManageVehicleService } from './manage-vehicle/manage-vehicle.service';
import { BnNgIdleService } from 'bn-ng-idle';
import { DomSanitizer } from '@angular/platform-browser';
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, InteractionStatus, RedirectRequest } from '@azure/msal-browser';
/** Flat node with expandable and level information */

export class DynamicFlatNode {
  constructor(
    public item: any, public level: number = 1, public expandable: boolean = false,
    public isLoading: boolean = false, public childrenLength: number = 0, public activeNode: boolean = false) { }
}

@Injectable()
export class DynamicDataSource implements OnInit {

  constructor(
    private storageService: TCCPLocalStorageService,
    private treeControl: FlatTreeControl<DynamicFlatNode>,
    public adminService: AdminService, private router: Router) {
    this.refreshTreeSubscription = this.adminService.refreshFeatureTree().subscribe(treeDetails => {
      this.isRefreshInProgress = true;
      const nodeDetails = treeDetails.treeDetails;
      if (nodeDetails) {
        if (!this.adminService.fromFeaturePage) {
          if (nodeDetails.type !== 'feature') {
            /* Add/Delete/Update node is type Step */
            this.isRefreshType = 'step';
            if (nodeDetails.node) {
              const selectChildNode = this.adminService.isSelectedNodeExpanded['node'];
              if ((nodeDetails.action && nodeDetails.action !== 'delete')) {
                if (nodeDetails.action === 'update') {
                  this.refreshAction = 'update';
                  let parentNode;
                  if (selectChildNode.level > 1) {
                    parentNode = this.getParent(selectChildNode);
                  } else {
                    parentNode = this.getFeatureByStep(selectChildNode);
                  }
                  this.updateSelectionNode = selectChildNode['item'];
                  this.addedNode = nodeDetails.node[nodeDetails.node.length - 1];
                  this.hightLightNode();
                  this.treeControl.collapse(parentNode);
                  this.treeControl.expand(
                    this.treeControl.dataNodes.find(n => n === parentNode)
                  );
                } else {
                  this.refreshAction = 'add';
                  if (selectChildNode.expandable && (!this.treeControl.isExpanded(selectChildNode))) {
                    this.addStep(nodeDetails);
                  } else {
                    let selectionNode = this.getParent(this.adminService.isSelectedNodeExpanded['node']);
                    selectionNode = selectionNode ? selectionNode : this.adminService.isSelectedNodeExpanded['node'];
                    this.addedNode = nodeDetails.node[nodeDetails.node.length - 1];
                    this.hightLightNode();
                    this.treeControl.collapse(selectionNode);
                    this.treeControl.expand(
                      this.treeControl.dataNodes.find(n => n === selectionNode)
                    );
                  }
                }
              } else {

                this.refreshAction = nodeDetails.action;
                let featureNode;
                if (this.adminService.isSelectedNodeExpanded['node'] &&
                  this.adminService.isSelectedNodeExpanded['node'].level &&
                  this.adminService.isSelectedNodeExpanded['node'].level > 0) {
                  featureNode = this.getFeatureByStep(this.adminService.isSelectedNodeExpanded['node']);
                } else {
                  featureNode = this.adminService.isSelectedNodeExpanded['node'];
                }
                this.addedNode = featureNode;
                this.onload();
                this.treeControl.dataNodes.forEach(node => {
                  if (node === featureNode) {
                    node.activeNode = true;
                  }
                });
                this.treeControl.collapseAll();
                const selectedIssueId: string = featureNode.item['issueId'];
                this.adminService.isFeatureInViewMode = true;
                this.adminService.isStepInViewMode = false;
                this.adminService.isSelectedNodeExpanded['node'] = featureNode;
                this.adminService.selectedNode = featureNode;
                this.adminService.selectedFeatureTargetId = selectedIssueId;
                this.adminService.expandedNode = [];
                this.adminService.expandedNode.splice(0, 0, featureNode);
                this.router.navigate(['admin/feature']);
              }
            }
          } else {
            this.onFeatureCreation(nodeDetails);
          }
        } else {
          // Add step from Feature Page
          if (nodeDetails.type === 'feature') {
            this.onFeatureCreation(nodeDetails);
            this.treeControl.dataNodes.forEach(node => {
              if (node.item.issueId === nodeDetails.node[nodeDetails.node.length - 1].issueId) {
                node.activeNode = true;
              }

            });
          } else {
            if (nodeDetails.action === 'add') {
              this.addStep(nodeDetails);
            }
          }
        }
      }
    });
    //  this.onload();
  }

  onFeatureCreation(nodeDetails) {
    /* Add/Delete/Update node is type Feature */
    this.isRefreshType = 'feature';
    this.isFeatureCreated = true;
    this.addedNode = nodeDetails.node[nodeDetails.node.length - 1];
    this.selectedType = nodeDetails.featureType;
    this.onload();
    if (nodeDetails.action === 'delete' || nodeDetails.action === 'copy') {
      this.router.navigate(['admin']);
    }
  }

  get data(): DynamicFlatNode[] { return this.dataChange.value; }

  set data(value: DynamicFlatNode[]) {
    this.treeControl.dataNodes = value;
    this.dataChange.next(value);
  }
  public dataMap;
  public rootLevelNodes = [];
  public expandedNodes: any = [];
  public isRefreshInProgress = false;
  public isRefreshType = '';
  public refreshAction = '';
  public addedNode: any = {};
  public refreshTreeSubscription: Subscription;
  public expandedAccordion: number;
  public selectedType: string = null;
  public featureContentTypes: Array<string> = [];
  public isFeatureCreated = false;
  public unsubscribe$: Subject<boolean> = new Subject();
  public previousExpandedNode: any;
  public updateSelectionNode: any;
  public contentTypes: Array<any> = [
    { name: 'INTERNAL', isExpanded: false },
    { name: 'EXTERNAL', isExpanded: false }
  ];

  dataChange: BehaviorSubject<DynamicFlatNode[]> = new BehaviorSubject<DynamicFlatNode[]>([]);

  addStep(nodeDetails) {
    let selectionNode = this.adminService.isSelectedNodeExpanded['node'];
    this.treeControl.dataNodes.forEach((data) => {
      if (data === selectionNode) {
        if (nodeDetails.node[nodeDetails.node.length - 1].controls && nodeDetails.node[nodeDetails.node.length - 1].controls.length &&
          nodeDetails.node[nodeDetails.node.length - 1].controls > 0) {
          if (data['item']['controls'] && data['item']['controls'].length > 0) {
            data['item']['controls'].forEach((control, controlIndex) => {
              if (data['item'].controlName === control.controlName) {
                data['item'].controls[controlIndex].targetId = nodeDetails.node[nodeDetails.node.length - 1].issueId;
                data['item']['targetId'] = null;
              }
            });
            data['item']['targetId'] = nodeDetails.node[nodeDetails.node.length - 1].issueId;
          } else {
            data['item']['targetId'] = nodeDetails.node[nodeDetails.node.length - 1].controls[0].issueId;
          }
        } else {
          if (data['item']['controls'] && data['item']['controls'].length > 0) {
            data['item']['controls'].forEach((control, controlIndex) => {
              if (data['item'].controlName === control.controlName) {
                data['item'].controls[controlIndex].targetId = nodeDetails.node[nodeDetails.node.length - 1].issueId;
                data['item']['targetId'] = null;
              }
            });
            data['item']['targetId'] = nodeDetails.node[nodeDetails.node.length - 1].issueId;
          } else {
            data['item']['targetId'] = nodeDetails.node[nodeDetails.node.length - 1].issueId;
          }

        }
        selectionNode = data;
      }
    });
    this.addedNode = nodeDetails.node[nodeDetails.node.length - 1];
    this.hightLightNode();
    this.treeControl.collapse(selectionNode);
    this.treeControl.expand(
      this.treeControl.dataNodes.find(n => n === selectionNode));
  }

  expandParents(node: DynamicFlatNode) {
    const parent = this.getParent(node);
    this.treeControl.collapse(parent);
    if (parent && parent.level > 0) {
      this.expandParents(parent);
    }
  }

  getParent(node: DynamicFlatNode) {
    const { treeControl } = this;
    const currentLevel = treeControl.getLevel(node);
    if (currentLevel < 1) {
      return null;
    }
    const startIndex = treeControl.dataNodes.indexOf(node) - 1;
    for (let i = startIndex; i >= 0; i--) {
      const currentNode = treeControl.dataNodes[i];
      if (treeControl.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
  }

  getFeatureByStep(node) {
    this.storageService.setSubTopic(null, null);
    const { treeControl } = this;
    const currentLevel = treeControl.getLevel(node);
    if (currentLevel < 1) {
      return null;
    }
    const startIndex = treeControl.dataNodes.indexOf(node) - 1;
    for (let i = startIndex; i >= 0; i--) {
      const currentNode = treeControl.dataNodes[i];
      if (treeControl.dataNodes[i].level === 1 && treeControl.dataNodes[startIndex + 1].level > 1 && this.storageService.getSubTopic().name === '') {
        this.storageService.setSubTopic(treeControl.dataNodes[i].item.controlName, '/admin/flow');
      }
      if (treeControl.getLevel(currentNode) < currentLevel && treeControl.getLevel(currentNode) === 0) {
        this.storageService.setFeature(currentNode.item.featureName, '/admin/flow');
        return currentNode;
      }
    }
  }

  hightLightNode() {
    this.treeControl.dataNodes.forEach(node => {
      node.activeNode = false;
    });
  }

  onload(contentType?: string, contentStatus?: string) {
    const resultData = [];
    let selectedFeatureType: string = null;
    selectedFeatureType = contentType;
    if (this.isRefreshInProgress) {
      selectedFeatureType = this.selectedType;
    }
    selectedFeatureType = selectedFeatureType ? selectedFeatureType.trim().toLowerCase() : null;
    this.adminService.getFlow(selectedFeatureType, this.adminService.selectedApplication, contentStatus).subscribe(response => {
      if (response) {
        response.filter(obj => {
          obj['controls'][0].issueId = obj['issueId'];
          obj['controls'][0].controlName = obj['controls'][0].featureName;
          obj['controls'][0].status = obj['status'];
          resultData.push(obj['controls'][0]);
        });
        const groupItemByFeatureType = _.sortBy(resultData, (item) => item.featureName.toLowerCase());
        this.rootLevelNodes = groupItemByFeatureType;
        this.dataMap = resultData;
        this.data = this.initialData();
        if (this.isRefreshInProgress) {
          this.hightLightNode();
          this.data.forEach((obj, index) => {
            this.isRefreshInProgress = false;
            if (this.addedNode) {
              const nodeDetails = this.addedNode;
              if (obj['item'].controlName === nodeDetails['item'].featureName) {
                this.data[index].activeNode = true;
                this.adminService.expandedNode = [];
                this.adminService.expandedNode.splice(0, 0, obj);
                this.adminService.isSelectedNodeExpanded['node'] = obj;
                if (this.isRefreshType === 'feature') {
                  this.adminService.activeFeature = nodeDetails['item'].featureName;
                  this.adminService.activeFeatureStatus = obj.item.status;
                  this.adminService.selectedFeatureTargetId = obj.item.issueId;
                  if (selectedFeatureType) {

                    this.contentTypes.forEach((n, index) => {
                      this.contentTypes[index]['isExpanded'] = false;
                      if (n.name.toLowerCase() === selectedFeatureType.toLowerCase()) {
                        this.contentTypes[index]['isExpanded'] = true;
                        this.expandedAccordion = n.name;
                      }
                    });
                    //  this.isFeatureCreated = false;
                  }
                }
              }
            }
          });
        }
      }
    });
  }

  initialData(): DynamicFlatNode[] {
    return this.rootLevelNodes.map(name => new DynamicFlatNode(name, 0, true));
  }

  isExpandable(node): boolean {
    if (typeof node === 'object') {
      return this.dataMap.has(node['targetId']);
    }
  }

  connect(collectionViewer: CollectionViewer): Observable<DynamicFlatNode[]> {
    this.treeControl.expansionModel.changed!.subscribe(change => {
      if (this.previousExpandedNode !== change) {
        if ((change as SelectionChange<DynamicFlatNode>).added ||
          (change as SelectionChange<DynamicFlatNode>).removed) {
          this.handleTreeControl(change as SelectionChange<DynamicFlatNode>);
          this.previousExpandedNode = Object.assign(change as SelectionChange<DynamicFlatNode>, change)
        }
      }
    });

    return merge(collectionViewer.viewChange, this.dataChange).pipe(map(() => this.data));
  }

  onTreeNodeClick(node, expand) {
    this.toggleNode(node, expand);
  }

  /** Handle expand/collapse behaviors */
  handleTreeControl(change: SelectionChange<DynamicFlatNode>) {
    if (change.added) {
      change.added.forEach((node) => { if (node) { this.toggleNode(node, true); } });
    }
    if (change.removed) {
      change.removed.reverse().forEach((node) => { if (node) { this.toggleNode(node, false); } });
    }
  }

  /**
   * Toggle the node, remove from display list
   */
  toggleNode(node: DynamicFlatNode, expand: boolean) {
    let children;
    this.adminService.getSubFlow(node['item']['targetId']).subscribe(response => {
      if (response) {
        response.filter(data => {
          if (data.controlName === '') {
            data.controlName = data.tagName;
          }
        });
        const map = new Map();
        map.set(node['targetId'], response);
        this.dataMap = new Map(map);
        children = response;

        this.adminService.childrenClone = children;

        const index = this.data.indexOf(node);
        if (!children || index < 0) { // If no children, or cannot find the node, no op
          return;
        }
        if (expand) {
          this.onExpandNode(node, children, index);
        } else {
          this.onCollapseNode(node, children, index);
        }
      }
    });
  }

  onExpandNode(node, children, index) {
    node.isLoading = true;
    setTimeout(() => {
      const nodes = children.map(name =>
        new DynamicFlatNode(name, node.level + 1, this.isExpandable(name)));
      this.data.splice(index + 1, 0, ...nodes);
      if (this.isRefreshInProgress) {
        this.data.forEach((obj, index) => {
          this.isRefreshInProgress = false;
          if (this.addedNode) {
            const nodeDetails = this.addedNode;
            if (nodeDetails['controls'] &&
              nodeDetails['controls'].length &&
              nodeDetails['controls'].length > 0) {
              if (this.refreshAction === 'update') {

                if ((obj.item.controlName === this.updateSelectionNode.controlName) && (obj.item.issueId === nodeDetails.issueId)) {
                  this.data[index].activeNode = true;
                  this.adminService.parentNode = this.data[index - 1];
                  this.adminService.selectedNode = obj;
                  this.adminService.isSelectedNodeExpanded['node'] = obj;
                  this.adminService.expandedNode.splice(0, 0, obj);
                  this.updateSelectionNode = {};
                }

              } else {
                if ((obj.item.controlName === nodeDetails['controls'][0].controlName) && (obj.item.issueId === nodeDetails.issueId)) {
                  this.data[index].activeNode = true;
                  this.adminService.parentNode = this.data[index - 1];
                  this.adminService.selectedNode = obj;
                  this.adminService.isSelectedNodeExpanded['node'] = obj;
                  this.adminService.expandedNode.splice(0, 0, obj);
                }
              }
            } else {
              if (obj.item.controlName === nodeDetails.tagName) {
                this.adminService.parentNode = this.data[index - 1];
                this.data[index].activeNode = true;
                this.adminService.isSelectedNodeExpanded['node'] = obj;
                this.adminService.expandedNode.splice(0, 0, obj);
              }
            }
          }
        });
      }
      // notify the change
      this.dataChange.next(this.data);
      node.isLoading = false;
    }, 500);
  }

  onCollapseNode(node, children, index) {
    let selectedFlowIndex = 0;
    selectedFlowIndex = this.data.indexOf(node);
    const childrenArray = [];
    let removeNode = true;
    let i = selectedFlowIndex + 1;
    for (i; i < this.data.length; i++) {
      if (removeNode) {
        if (this.data[i].level > node.level) {
          childrenArray.push(this.data[i]['item'].issueId);
        } else if (this.data[i].level === node.level) {
          removeNode = false;
        }
      }
    }

    for (let i = 0; i < this.data.length; i++) {
      for (let j = 0; j < childrenArray.length; j++) {
        if (this.data[i]['item']['issueId'] === childrenArray[j]) {
          this.data.splice(i, 1);
        }
      }
    }

    this.dataChange.next(this.data);
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

}


@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})

export class AdminComponent implements OnInit, OnDestroy {
  @ViewChild('supportTopicPanel', { static: false }) private supportTopicPanel1: MatExpansionPanel;
  @ViewChild('featureAccordion', { static: false }) private featureAccordion: MatAccordion;
  @ViewChild('internalSupportTopicPanel', { static: false }) internalSupportTopicPanel: MatExpansionPanel;
  @ViewChild('externalSupportTopicPanel', { static: false }) externalSupportTopicPanel: MatExpansionPanel;

  private readonly _destroying$ = new Subject<void>()
  public loginDisplay = false;
  


  constructor(
    public router: Router, public adminService: AdminService,
    private dialog: MatDialog, private storageService: TCCPLocalStorageService,
    public commonService: TCCPCommonService,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private vehicleService: ManageVehicleService, private bnIdle: BnNgIdleService,
    @Inject(DOCUMENT) private _document: HTMLDocument, private dom: DomSanitizer,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,) {

    this.adminService.closeFeatureExpansionPanel.subscribe(flag => {
      if (flag) {
        this.featureAccordion.closeAll();
      }
    });

    this.treeControl = new FlatTreeControl<DynamicFlatNode>(this.getLevel, this.isExpandable);
    if (_.isNil(this.storageService.getSelectedApp())) {
      this.selectedApp = this.applist[0];
      this.theme = environment.applicationName + '-' + this.selectedApp.value;
      this.storageService.setSelectedDivision(this.selectedApp);
    } else {
      this.selectedApp = this.storageService.getSelectedApp();
      this.theme = environment.applicationName + '-' + this.selectedApp.value;
    }
    this.adminService.selectedApplication = this.selectedApp['value'];
    this.dataSource = new DynamicDataSource(this.storageService, this.treeControl, adminService, router);
    this.nodes = [];
  }

  public nodes: any[] = [];
  private onClose: Subject<Object>;
  public vehicleClassification: any[];
  public setMultiOption = false;
  @ViewChild('modelList', { static: false }) private modelListFilter: MatSelectionList;
  @ViewChild('classificationList', { static: false }) private classificationListFilter: MatSelectionList;
  @ViewChild('yearList', { static: false }) private yearFilter: MatSelectionList;
  @ViewChild('generationList', { static: false }) private generationFilter: MatSelectionList;

  public selectedType: string = null;
  public pageNodes: any[] = [];
  public featureList = [];
  public selectedApp: any;
  public switchApp: any;
  public currentAppSelection: any;
  public appName: string = environment.applicationName;
  public featureContentStatus = 'published';
  public theme: string = environment.applicationName;

  public applist = [{ name: 'Toyota', icon: '../../assets/images/common/ToyotaLogoNew.png', value: 'toyota' },
  { name: 'Lexus', icon: '../../assets/images/common/logo-Lexus.png', value: 'lexus' }];

  public menuList = [
    {
      controlName: 'Manage Support Topics',
      subMenu: [
        {
          url: '/admin',
          controlName: 'Dashboard'
        },
        {
          url: '/admin/feature',
          controlName: 'Add Support Topic'
        },
        {
          url: '/admin/manage-mapping',
          controlName: 'Manage Mapping'
        },
        {
          url: '/admin/manage-cvs-mapping',
          controlName: 'Manage CVS Mapping'
        },
        {
          url: '/admin/manage-category-mapping',
          controlName: 'Manage Support Topics Order'
        }

      ]
    },
    {
      url: '/admin/vehicle',
      controlName: 'Manage Model And Year'
    },
    {
      controlName: 'Manage Contents',
      subMenu: [
        {
          url: '/admin/manage-documents',
          controlName: 'Manage Documents'
        },
        {
          url: '/admin/manage-disclaimer',
          controlName: 'Manage Disclaimer'
        },
        {
          url: '/admin/manage-resources',
          controlName: 'Manage Resources'
        },
        {
          url: '/admin/manage-videos',
          controlName: 'Manage Videos'
        },
        {
          url: '/admin/manage-message-guide',
          controlName: 'Manage Message Guide'
        },
        {
          url: '/admin/manage-banners',
          controlName: 'Manage Banners'
        },
        {
          url: '/admin/badge-management',
          controlName: 'Manage Badges'
        }
      ]
    }
  ];
  public seletedMenu: any;
  public subscribeEvent: any;
  public roleAccessMap: any;
  treeControl: FlatTreeControl<DynamicFlatNode>;
  dataSource: DynamicDataSource;
  public isSideNavOpen = true;
  public contentMargin = 350;
  @ViewChildren('sideNavSearch') sideNavSearch: QueryList<ElementRef>;
  public focusSearch = true;
  public toyLogo: any;
  public lexLogo: any;


  getSideNavToggleButtonBackground() {
    return this.selectedApp.value === 'lexus' ? '#B6A171' : '#CC0000';
  }

  toggleSideNavBar(toggleEvent?: string) {
    if (toggleEvent && toggleEvent === 'search') {
      this.focusSearch = true;
    } else {
      this.focusSearch = false;
    }
    this.isSideNavOpen = !this.isSideNavOpen;
    this.contentMargin = this.isSideNavOpen ? 350 : 40;
  }

  ngAfterViewInit() {
    this.setFocusOnSearch();
    this.sideNavSearch.changes.subscribe(() => {
      this.setFocusOnSearch();
    });
  }

  setFocusOnSearch() {
    if (this.focusSearch && this.sideNavSearch.length > 0) {
      this.sideNavSearch.first.nativeElement.focus();
    }
  }

  modelFilterChange(event: MatSelectionListChange) {
    this.setFilterOnChange(TCCPConstantValues.admin.FIXED_VALUES.MODEL, event);
    this.adminService.modelFilterEmmiter.emit(true);
  }
  classificationFilterChange(event: MatSelectionListChange) {
    this.setFilterOnChange(TCCPConstantValues.admin.FIXED_VALUES.CLASSIFICATION, event);
    this.adminService.modelFilterEmmiter.emit(true);
  }
  yearFilterChange(event: MatSelectionListChange) {
    this.setFilterOnChange(TCCPConstantValues.admin.FIXED_VALUES.YEAR, event);
    this.adminService.yearFilterEmmiter.emit(true);
  }
  generationFilterChange(event: MatSelectionListChange) {
    this.setFilterOnChange(TCCPConstantValues.admin.FIXED_VALUES.GENERATION, event);
    this.adminService.generationFilterEmmiter.emit(true);
  }
  
  setFilterOnChange(filterType: string, event) {
    const generations: Array<string> = [];
    const classification: Array<string> = [];
    const years: Array<string> = [];

    if (filterType === TCCPConstantValues.admin.FIXED_VALUES.MODEL) {
      this.adminService.modelFilter = event.source.selectedOptions.selected.map((data => data.value));
      if (!_.isEmpty(this.adminService.modelFilter)) {
        this.adminService.vehicleList.forEach(model => {
          if (this.adminService.modelFilter.includes(model.model)) {
            classification.push(model.classification);
          }
        });
        this.adminService.vehicleClassification = _.uniq(classification);
      } else {
        this.adminService.vehicleClassification = this.adminService.vehicleList.map(x => x.classification);
      }
    }

    if (filterType === TCCPConstantValues.admin.FIXED_VALUES.CLASSIFICATION) {
      this.adminService.classificationFilter = event.source.selectedOptions.selected.map((data => data.value));
      // Filter models on classification filter
      this.adminService.filterdModelList = !_.isEmpty(this.adminService.classificationFilter) ?
        // tslint:disable-next-line:max-line-length
        this.adminService.vehicleList.filter(model => this.adminService.classificationFilter.includes(model.classification)) : this.adminService.vehicleList;
      // Filter year on classification
      const modelYearList = this.adminService.filterdModelList.map(x => x.years);
      modelYearList.forEach(modelYears => {
        modelYears.forEach(modelYear => {
          years.push(String(modelYear.year));
          if (!_.isNil(modelYear.generation)) {
            generations.push(modelYear.generation);
          }
        });
      });
      // Set Generation on classification
      this.adminService.generationList = _.uniq(generations);
      this.adminService.yearList = _.uniq(years);
    }

    if (filterType === TCCPConstantValues.admin.FIXED_VALUES.YEAR) {
      this.adminService.yearFilter = event.source.selectedOptions.selected.map((data => data.value));
    }

    if (filterType === TCCPConstantValues.admin.FIXED_VALUES.GENERATION) {
      this.adminService.generationFilter = event.source.selectedOptions.selected.map((data => data.value));
    }
  }

  clearAll() {
    this.modelListFilter.deselectAll();
    this.classificationListFilter.deselectAll();
    this.yearFilter.deselectAll();
    this.adminService.modelFilter = [];
    this.adminService.classificationFilter = [];
    this.adminService.yearFilter = [];
    this.adminService.modelFilterEmmiter.emit(true);
  }

  getLevel = (node: DynamicFlatNode) => node.level;

  isExpandable = (node: DynamicFlatNode) => node.expandable;

  hasChild = (_: number, _nodeData: DynamicFlatNode) => {
    if ((_nodeData.item.tagName === undefined) || (_nodeData.item.tagName === '')) {
      _nodeData.expandable = true;
    } else {
      _nodeData.expandable = false;
    }
    return _nodeData.expandable;
  }

  changeState(node) {
    node.exapanded = !node.exapanded;
  }

  ngOnInit() {
    this.msalBroadcastService.inProgress$
    .pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None),
      takeUntil(this._destroying$)
    )
    .subscribe(() => {
      this.setLoginDisplay();
      this.checkAndSetActiveAccount();
    })

    this.msalBroadcastService.msalSubject$.pipe(
      filter((message: EventMessage) => message.eventType === EventType.LOGIN_SUCCESS),
    )
    .subscribe((message: EventMessage) =>{
      const authResult = message.payload as AuthenticationResult;
      if(authResult !== undefined && authResult !== null){
            var token = JSON.stringify({token:authResult?.accessToken})
            var expiresOn = JSON.stringify({expiresOn:authResult?.expiresOn})
            this.storageService.setTokenExpiry(expiresOn);
            this.storageService.setToken(token);
          }

      this.authService.instance.setActiveAccount(authResult.account);
      this.storageService.setUpn(this.authService.instance.getActiveAccount().username);
    })

    this.lexLogo = environment.baseURL + 'content/lexus/common/external-logo.png';
    this.toyLogo = environment.baseURL + 'content/toyota/common/external-logo.png';
    this.selectedType = this.dataSource.selectedType;
    const upn = this.storageService.getUpn();
    this.setAccessRole(upn);
    this.setAccessPolicy();
    this.onClose = new Subject();
    this.seletedMenu = this.menuList[0].subMenu[0];
    this.adminService.isStepInViewMode = false;
    this.adminService.isFeatureInViewMode = false;
    this.dataSource.onload(this.dataSource.selectedType, this.featureContentStatus);
    this._document.getElementById('appFavicon').setAttribute('href', 'assets/images/admin/favicon.ico');
    this.storageService.setSwitchApp(false);
    this.vehicleService.getAllVehicle().subscribe((data: any) => {
      this.storageService.setCachedVehicles(data);
    });
    this.adminService.getFlow().subscribe((data: any) => {
      data.filter(control => {
        control.controls.filter(obj => {
          this.featureList = this.featureList.concat({
            issueId: control.issueId,
            featureName: obj.featureName, featureType: control.featureType
          });
        });
      });
      this.storageService.setCachedFeatures(this.featureList);
    });
    // this.authService.httphandleCallback();
    // if (this.authService.instance.getActiveAccount()!=null) {
    //   this.bnIdle.startWatching(900).subscribe((res) => {
    //     if (res) {
    //       this.authService.RenewToken('https://graph.microsoft.com');
    //       this.authService.acquireToken('https://graph.microsoft.com').subscribe((token) => {
    //       });
    //     }
    //   });
    // }
  }
  setAccessPolicy() {
    this.commonService.getAccessPolicy().subscribe((response: any) => {
      response.forEach(accessPolicy => {
        const permissionArray: Array<Permission> = [];
        const accessModules = _.get(accessPolicy, 'modules');
        accessModules.forEach(module => {
          const permission: Permission = {
            feature: _.get(module, 'featName'),
            accessLevel: _.get(module.permissions[0], 'accessLevel'),
            contextUrl: _.get(module, 'contextUrl'),
            allowedMethod: _.get(module, 'allowedMethods'),
          };
          permissionArray.push(permission);
        });
        this.storageService.setPermission(_.get(accessPolicy, 'userRole'), JSON.stringify(permissionArray));
      });
    });
  }

  setAccessRole(upn) {
    this.commonService.getAccessRole(upn).subscribe((response: any) => {
    const newRoles = _.get(response, '[0].roles', []); 

    if (newRoles.length > 0) {
      const existingRoles = this.storageService.getRoles() || [];
      const mergedRoles = _.union(existingRoles, newRoles);
      this.storageService.setRoles(mergedRoles);
    }
  });
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }


  checkAndSetActiveAccount(){
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount();
    if(activeAccount){
      this.storageService.setUpn(this.authService.instance.getActiveAccount().username);
      this.storageService.setRoles(this.authService.instance.getActiveAccount().idTokenClaims.roles);
    }

    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
      this.storageService.setUpn(this.authService.instance.getActiveAccount().username);
    }
  }

  loginRedirect() {
    if (this.msalGuardConfig.authRequest){
      this.authService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }

  public onchangeApp(app) {
    this.currentAppSelection = Object.assign({}, this.selectedApp);
    if (this.currentAppSelection.name === app.name) {
      this.dataSource.onload();
    } else {
      this.switchApp = app;
      if (this.router.url === '/admin/addVehicle') {
        this.adminService.editModeNavigation.emit(true);
        this.subscribeEvent = this.adminService.editModeNavigation.subscribe(data => {
          if (!data) {
            this.openDivisionChangeDialog();
          }
        });
      } else {
        this.openDivisionChangeDialog();
      }
    }
  }

  getName(){
    return this.storageService.getUpn();
  }

  openDivisionChangeDialog() {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      data: `Are you sure you want to exit/sign out from ${this.currentAppSelection.name} Admin portal?`,
      position: { top: '100px' },
      id: 'admin-' + this.adminService.selectedApplication
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.storageService.setSwitchApp(true);
        this.selectedApp = this.switchApp;
        this.theme = environment.applicationName + '-' + this.selectedApp.value;
        this.adminService.selectedApplication = this.selectedApp.value;
        this.storageService.setSelectedDivision(this.selectedApp);
        this.router.navigateByUrl('/admin');
        this.seletedMenu = this.menuList[0].subMenu[0];
        this.adminService.refreshDraftFeatures.emit(true);
        this.adminService.refreshDashboard.emit(true);
        this.adminService.refreshToVehicle.emit(true);
        this.storageService.setCachedVehicles(null);
        this.storageService.setCachedFeatures(null);
        this.dataSource.onload(this.dataSource.selectedType);
      } else {
        this.selectedApp = this.currentAppSelection;
        this.theme = environment.applicationName + '-' + this.selectedApp.value;
        this.adminService.selectedApplication = this.currentAppSelection.value;
        this.storageService.setSelectedDivision(this.selectedApp);
      }
    });
  }

  public menuSelection(menu) {
    this.adminService.closeFeatureExpansionPanel.emit(true);
    this.seletedMenu = menu;
    if (menu.url === '/admin/feature') {
      this.addFeature();
    } else {
      if (!(menu.url === '/admin' || menu.url === 'admin/flow')) {
        // reset side nav visibility to open on redirection
        this.isSideNavOpen = true;
        // when redirected(from '/admin' || '/admin/feature' || 'admin/flow' ) to manage model&year
        // reset margin-left(of router outlet) to default(i.e 350px)
        this.contentMargin = 350;
      }
      this.router.navigateByUrl(menu.url);
    }
  }

  public onNodeSelection(node) {
    this.adminService.addStepClicked = false;
    if (this.adminService.featureDataChanged === true) {
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '350px',
        data: TCCPConstantValues.admin.messages.LOST_UNSAVED_MESSAGE,
        id: 'admin-' + this.adminService.selectedApplication,
        position: { top: '100px' }
      });
      this.adminService.featureDataChanged = false;
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.onNodeSelection(node);
        } else {
          const activeFeatureNode = this.adminService.nodeBeforeFeatureChange;
          activeFeatureNode.activeNode = true;
          node.activeNode = false;
        }
      });
    }

    if (this.adminService.stepDataChanged === true) {
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '350px',
        data: TCCPConstantValues.admin.messages.LOST_UNSAVED_MESSAGE,
        id: 'admin-' + this.adminService.selectedApplication,
        position: { top: '100px' }
      });
      this.adminService.stepDataChanged = false;
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.onNodeSelection(node);
        } else {
          const activeFeatureNode = this.adminService.nodeBeforeStepChange;
          activeFeatureNode.activeNode = true;
          node.activeNode = false;
        }
      });
    }

    this.dataSource.hightLightNode();
    this.adminService.selectedNode = node;
    this.adminService.isSelectedNodeExpanded = { node: node, exapanded: this.treeControl.isExpanded(node) };
    const activeFeatureNode = node && node.level && node.level > 0 ? this.dataSource.getFeatureByStep(node) : node;
    if (activeFeatureNode) {
      this.adminService.activeFeature = activeFeatureNode['item']['featureName'];
      this.adminService.activeFeatureStatus = activeFeatureNode['item']['status'];
    }
    node.activeNode = true;
    this.adminService.expandedNode = [];
    this.adminService.expandedNode.splice(0, 0, node);
    const selectedNodeIndex = this.dataSource.data.indexOf(node);
    this.adminService.parentNode = this.dataSource.data[selectedNodeIndex - 1];
    if (node && node.level) {
      const selectedTargetId: string = node.item['issueId'];
      this.adminService.isStepInViewMode = true;
      this.adminService.selectedStepIssueId = selectedTargetId;
      const flowRoute = this.router.url === '/admin/flow';
      if (flowRoute) {
        this.adminService.navigateToFlow.emit({ mode: TCCPConstantValues.admin.FIXED_VALUES.VIEW, fromAdmin: true });
      } else {
        this.router.navigate(['admin/flow']);
      }
    } else {
      const selectedIssueId: string = node.item['issueId'];
      this.adminService.isFeatureInViewMode = true;
      this.adminService.selectedFeatureTargetId = selectedIssueId;
      const flowRoute = this.router.url === '/admin/feature';
      if (flowRoute) {
        this.adminService.navigateToFeature.emit({ mode: TCCPConstantValues.admin.FIXED_VALUES.VIEW, fromAdmin: true });
      } else {
        this.router.navigate(['admin/feature']);
      }
    }
  }

  beforeFeaturePanelOpened(contentType, contentStatus?: string) { // EXT or INT panel open event
    this.focusSearch = true;
    if (contentType === 'internal') {
      this.externalSupportTopicPanel.close();
      // this.dataSource.contentTypes[1].isExpanded = true;
    } else {
      this.internalSupportTopicPanel.close();
      //  this.dataSource.contentTypes[0].isExpanded = true;
    }
    this.setMultiOption = false;
    // this.featureAccordion.closeAll();
    this.dataSource.expandedAccordion = contentType;
    this.dataSource.selectedType = !_.isNil(contentType) ? contentType.trim().toLowerCase() : contentType;

    if (!this.dataSource.isFeatureCreated) {
      this.dataSource.data = [];
      contentType = contentType ? contentType.trim().toLowerCase() : null;
      this.dataSource.onload(contentType, this.featureContentStatus);
    }
    this.dataSource.isFeatureCreated = false;
  }

  addFeature() {
    this.adminService.isFeatureInViewMode = false;
    this.adminService.addStepClicked = true;
    this.adminService.expandedNode = [];
    const flowRoute = this.router.url === '/admin/feature';
    if (flowRoute) {
      this.adminService.navigateToFeature.emit({ mode: TCCPConstantValues.admin.FIXED_VALUES.ADD, fromAdmin: true });
    } else {
      this.router.navigate(['admin/feature']);
    }
  }

  publishFeature() {
    this.router.navigate(['admin/publish']);
  }

  onLogout() {
    
    const env = window.location.host.split('.')[0];
    let externalUrl;
    if(env === 'dev' || env === 'qa'){
      externalUrl = this.selectedApp.value === 'toyota' ? `${env}.${TCCPConstantValues.base.url_contexts.TOYOTA_EXTERNAL}.com` : `${env}.${TCCPConstantValues.base.url_contexts.LEXUS_EXTERNAL}.com`;
    }else{
      externalUrl = this.selectedApp.value === 'toyota' ? `${TCCPConstantValues.base.url_contexts.TOYOTA_EXTERNAL}.com` : `${TCCPConstantValues.base.url_contexts.LEXUS_EXTERNAL}.com`;
    }
    this.storageService.setToken('');
    const externalLink = `${environment.protocol}//${externalUrl}/${this.selectedApp.value}/home`
    this.authService.logoutRedirect({postLogoutRedirectUri: `${environment.protocol}//${externalUrl}/${this.selectedApp.value}/home`});
  }

  ngOnDestroy() {
    if (this.subscribeEvent) {
      this.subscribeEvent.unsubscribe();
    }
    this._destroying$.next(undefined);
    this._destroying$.complete();

  }

  public filterChanged(filterText) { // side nav search
    let filteredTreeData;
    if (filterText) {
      filteredTreeData = this.dataSource.data.filter(
        d => d.item.controlName.toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) > -1);
    } else {
      this.beforeFeaturePanelOpened(this.dataSource.selectedType, this.featureContentStatus);
    }
    if (this.dataSource.selectedType === 'internal') {
      this.dataSource.data = filteredTreeData;
      this.internalSupportTopicPanel.expanded = true;
    } else if (this.dataSource.selectedType === 'external') {
      this.dataSource.data = filteredTreeData;
      this.externalSupportTopicPanel.expanded = true;
    } else {
      this.dataSource.selectedType = 'internal';
      this.internalSupportTopicPanel.expanded = true;
      this.beforeFeaturePanelOpened(this.dataSource.selectedType, this.featureContentStatus);
    }
  }
  public onValChange(value) { // value - publish or draft
    this.focusSearch = true;
    this.setFocusOnSearch();
    this.featureContentStatus = value;
    this.beforeFeaturePanelOpened(this.dataSource.selectedType, this.featureContentStatus);
  }
}
